<template>
  <div class="mt-5">
    <h2 class="text-xl font-extrabold text-center">{{ title }}</h2>
    <div class="options">
      <div class="option" v-bind:class="calculateSelectedClass(option)" v-bind:key="option" v-for="option in options"
           @click="toggleOption(option)">{{ option }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SurveyQuestionMultiple',
  components: {},
  props: {
    title: {},
    options: {},
    questionId: {},
    initialValue: {
      default: null
    },
  },
  data () {
    return {
      selected: {},
    }
  },
  created () {
    if (this.initialValue) {
      this.selected = [this.initialValue]
      this.change()
    }
  },
  methods: {
    change () {
      const selectedOptions = Object.entries(this.selected)
        .filter(([, value]) => value === true)
        .map(([key]) => key)
      let value = {
        'option': JSON.stringify(selectedOptions, null, 2),
        'questionId': this.questionId
      }
      this.$emit('change', value)
    },
    calculateSelectedClass (option) {
      return {
        'selected': this.selected[option]
      }
    },
    toggleOption (option) {
      if (!this.selected[option]) {
        this.selected[option] = true
      } else {
        this.selected[option] = !this.selected[option]
      }
      this.change()
    }
  }
}
</script>

<style lang="css" scoped>

.options {
  @apply flex justify-center gap-4 mt-5 mb-5 text-center flex-wrap md:flex-nowrap;
}

.option {
  @apply p-2 pl-5 pr-5 rounded cursor-pointer flex items-center justify-center text-center border-none;
  background-color: #f5f5f5;
}

.option.selected, .option:hover {
  background-color: var(--tus-green);
  color: white;
}

</style>
